"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsquishToRecord = exports.unsquishTaskIdentification = exports.squishRecord = exports.SquishableRecordType = void 0;
const btoa_lite_1 = __importDefault(require("btoa-lite"));
const atob_lite_1 = __importDefault(require("atob-lite"));
const exceptions_1 = require("../exceptions");
const json_util_1 = require("./json-util");
var SquishableRecordType;
(function (SquishableRecordType) {
    SquishableRecordType["TaskIdent_Main_1"] = "TaskIdent_Main_1";
})(SquishableRecordType = exports.SquishableRecordType || (exports.SquishableRecordType = {}));
const FieldsBySquishableRecordType = {
    [SquishableRecordType.TaskIdent_Main_1]: [
        'authorEnv',
        'authoringProjectUid',
        'examSuiteUid',
        'kahbaRuntimeUid',
        'organizationUid',
        'scriptBuildUid',
        'structureUid',
        'taskSid',
    ],
};
function squishRecord(type, data, squishRecordOpts = {}) {
    let res;
    if (type === SquishableRecordType.TaskIdent_Main_1) {
        if (data.automationProjectUid) { // during rename transition
            data.authoringProjectUid = data.authoringProjectUid || data.automationProjectUid;
        }
        res = _arrayOfValues(FieldsBySquishableRecordType[SquishableRecordType.TaskIdent_Main_1], data);
    }
    else {
        throw new exceptions_1.PlusPlusPlus('UnknownSquishableRecordType', { type, squishRecordOpts });
    }
    res = json_util_1.safeStringify(res);
    if (squishRecordOpts.usingBase64) {
        res = btoa_lite_1.default(res);
    }
    return res;
}
exports.squishRecord = squishRecord;
function unsquishTaskIdentification(values, squishRecordOpts) {
    return unsquishToRecord(SquishableRecordType.TaskIdent_Main_1, values, squishRecordOpts);
}
exports.unsquishTaskIdentification = unsquishTaskIdentification;
function unsquishToRecord(type, data, squishRecordOpts = {}) {
    if (squishRecordOpts.usingBase64) {
        data = atob_lite_1.default(data);
    }
    data = json_util_1.parsedJsonOrNothing(data);
    if (!data) {
        throw new exceptions_1.PlusPlusPlus('UnexpectedData', {
            reason: 'Failed to parse json so cannot hydrate passed-in data into the desired record type',
            type,
        });
    }
    const res = {};
    if (type === SquishableRecordType.TaskIdent_Main_1) {
        const keys = FieldsBySquishableRecordType[SquishableRecordType.TaskIdent_Main_1];
        _assertExpectedLength(data, keys.length);
        keys.forEach((k, ndx) => {
            const val = data[ndx];
            if (val !== undefined && val !== null) {
                res[k] = data[ndx];
            }
        });
    }
    else {
        throw new exceptions_1.PlusPlusPlus('UnknownSquishableRecordType', { type, squishRecordOpts });
    }
    return res;
}
exports.unsquishToRecord = unsquishToRecord;
function _assertExpectedLength(data, len) {
    if (!Array.isArray(data)) {
        throw new exceptions_1.PlusPlusPlus('UnexpectedDataType', {
            reason: 'could not hydrate passed-in data, expecting an array of exact length',
            expectedLength: len,
            typeofDataPassed: typeof data,
        });
    }
    if (data.length !== len) {
        throw new exceptions_1.PlusPlusPlus('UnexpectedDataType', {
            reason: 'Expecting an array of exact length',
            expectedLength: len,
            actualLength: data.length,
        });
    }
}
function _arrayOfValues(keys, data) {
    return keys
        .sort()
        .map(key => data[key]);
}
//# sourceMappingURL=squished-record-util.js.map